
import React, {} from "react";
import { Switch, Route, useParams, Redirect } from "react-router-dom";
import "./index.css"
import "./App.less";
import "antd/dist/antd.less";
import Connect from "./Pages/Connect.jsx";
import NotFound from "./Pages/NotFound.jsx";
import Settings from "./Pages/Settings.jsx";
import ConnectionStatus from "./Pages/ConnectionStatus.jsx";
import Data from "./Pages/Data.jsx";
import SideBar from "./Components/SideNavbar";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import UserAgreement from "./Pages/UserAgreement";
import Onboarding from "./Pages/Onboarding";
import UserUnAuthorized from "./Pages/UnAuthorizedUser"
import { Layout,  } from "antd";
import Welcome from "./Pages/Welcome";
import { useJwt } from "react-jwt";
import LearnMore from "./Pages/LearnMore";
import Faqs from "./Pages/Faqs";
import  GetStarted  from "./Pages/GetStarted";
 import AppFooter from "./Components/Footer";
const {Sider, Footer } = Layout;

function App() {
  // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wX2lkIjoxLCJzaG9wIjoiZmFyb2doZGVtby5teXNob3BpZnkuY29tIiwiaWF0IjoxNjUwNTE4MjQwLCJleHAiOjE2NTA1MTk0NDB9.RPvIjmp1-aU8pMnNos8ZzK55pqInXcQUeAq7MMEznSc
  const ProtectedRoute = ({ token, children }) => {
    var User = JSON.parse(localStorage.getItem("User"));
    const { decodedToken, isExpired } = useJwt(User?.token);
    const params = useParams();
     
    // console.log("Deocde token in protected route", decodedToken);
    // console.log("Token Expiry in Protected route: ", isExpired);
    
    try {

      if (User) {
        // console.log("Token Expiry in Protected route: ", isExpired)
        if (
          User.isValidUser == false ||
          params.companyId != User.comp_id 
          // || isExpired 
        ) {
          // return <Redirect to="/unAuthorizedUser" />;
          if(decodedToken){
            console.log("Shop Name from decoded token:", decodedToken.shop);
            window.location.replace('https://'+ decodedToken.shop +'/admin/apps');
            return null;
            
          }
        }  
      } else {
        console.log("User Did not login any time in this browser");
        //  return <Redirect to="/unAuthorizedUser" />;
        return  window.location.replace('https://accounts.shopify.com/');
      }
    } catch (err) {
      console.log(err);
    }

    return children;
  };

  return (
    <React.StrictMode>
      <Switch>
        <Route exact path="/">
          <NotFound />
        </Route>
        <Route path="/welcome/:token">
          <Welcome />
        </Route>
        <Route path="/getStarted/:token">
          <GetStarted />
        </Route>
        <Route path="/onboarding">
          <Onboarding />
        </Route>
        
        <Route path="/privacyPolicy"> 
          <PrivacyPolicy />
        </Route>
        <Route path="/userAgreement">
          <UserAgreement />
        </Route>
        <Route path="/learnMore">
          <LearnMore />
        </Route>
        <Route path="/faqs">
          <Faqs />
        </Route>
        <Route path="/unAuthorizedPage">
          <UserUnAuthorized />
        </Route>
         

        <Route path="/unAuthorizedUser" 
          component={() => {
            var User = JSON.parse(localStorage.getItem("User"));
            if(User){
              return window.location.replace('https://'+ User.storeName +'/admin/apps');
               
            }else{
              return  window.location.replace('https://accounts.shopify.com/');
            }
              
            }}
       />

        <div className="">
          <Layout>
            <Sider
              width={240}
              className="h-full w-64  "
            >
              <SideBar />
            </Sider>
 
            <Layout>
              <Route exact path="/:companyId">
                <ProtectedRoute>
                  <Connect />
                </ProtectedRoute>
              </Route>
              <Route exact path="/:companyId/connectionStatus">
                <ProtectedRoute>
                  <ConnectionStatus />
                </ProtectedRoute>
              </Route>
              <Route exact path="/:companyId/data">
                <ProtectedRoute>
                  <Data />
                </ProtectedRoute>
              </Route>
              <Route exact path="/:companyId/settings">
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              </Route>

              
                {/* <AppFooter/> */}
            </Layout>
 
          </Layout>
        </div>
      </Switch>
    </React.StrictMode>
  );
}

export default App;
